import _debounce from 'lodash/debounce'
import _uniq from 'lodash/uniq'
import _flattenDeep from 'lodash/flattenDeep'
import _groupBy from 'lodash/fp/groupBy'
import _flatMap from 'lodash/fp/flatMap'
import { ref, computed } from '@vue/composition-api'
import store from '@/store'
import effectiveDatesRangeLookup from '@/utils/effectiveDatesRangeLookup'

const coursesStore = ref({})
const courseGroupIds = ref([])
const isLoading = ref(false)

async function _fetchCourses (params) {
  const ids = [ ...courseGroupIds.value ]
  courseGroupIds.value = []

  coursesStore.value = await store.dispatch('curriculumCourses/getCourses', {
    ...params,
    courseGroupIds: _uniq(_flattenDeep(ids)),
    columns: [ ...params.columns, 'code', 'longName', 'name', 'deprecatedId' ],
    limit: 2000,
  })

  isLoading.value = false
  return coursesStore
}
const _fetchCoursesDebounced = _debounce(_fetchCourses, 150)

async function _fetchCourse ({ courseGroupId, ...params }) {
  isLoading.value = true
  courseGroupIds.value.push(courseGroupId)
  return _fetchCoursesDebounced({ ...params })
}

export default function useSharedCourses ({ school = store.getters.school } = {}) {
  const mergedCoursesStore = computed(() => ({
    ...store.state.curriculumCourses.courses,
    ...coursesStore.value,
  }))

  const getCourseByDatesRangeLookup =
    ({ courseGroupId, effectiveDatesRange, groupIdAttribute, useFetchRequisitesWithLatestRevision, mergeDuplicateCourses = false }) => {

      const mergedCoursesStoreUniqueById = mergedCoursesStore.value && mergeDuplicateCourses
        ? _flatMap(
          group => Object.assign(...group),
          _groupBy('_id', Object.values(mergedCoursesStore.value)),
        )
        : mergedCoursesStore.value

      return effectiveDatesRangeLookup({
        resources: mergedCoursesStoreUniqueById,
        groupIdAttribute: groupIdAttribute || 'courseGroupId',
        effectiveDatesRange: effectiveDatesRange.value,
        groupIdValue: courseGroupId.value,
        useFetchRequisitesWithLatestRevision,
      })
    }

  return {
    courses: mergedCoursesStore,
    getCourseByDatesRangeLookup,
    fetchCourse: (params) => _fetchCourse({ school, ...params }),
    isLoading,
  }
}
